import { parseISO } from 'date-fns';

const parseToLocalDate = (dateStr: string) => {
  const date = parseISO(dateStr);
  date.setHours(0, 0, 0, 0);
  return date;
};

export default parseToLocalDate;
